import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Paper from '@mui/material/Paper';
import PageWithSidebar from 'components/PageWithSidebar';
import EntityEditPageSkeleton from 'components/EntityEditPageSkeleton';
import NotFound from 'components/NotFound';
import TableSkeleton from 'components/TableSkeleton';
import EntitySidebar from 'components/EntitySidebar';
import MenuItemsList from 'components/MenuItemsList';

import { withData } from 'lib';
import { ContentMenuEditPageQuery } from '__generated__/ContentMenuEditPageQuery.graphql';

const query = graphql`
  query ContentMenuEditPageQuery($id: ID!) {
    menu(id: $id) {
      displayName

      ...EntitySidebar_entity
      ...MenuItemsList_menu
    }
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<ContentMenuEditPageQuery>;
};

type RouteParams = {
  id: string;
};

const breadcrumbs = [
  { link: '/content', name: 'Turinys' },
  { link: '/content/menu', name: 'Meniu' },
];

const ContentMenuEditPage: FC<Props> = ({ preloadedQuery }) => {
  const { menu } = usePreloadedQuery<ContentMenuEditPageQuery>(
    query,
    preloadedQuery
  );

  if (!menu) {
    return <NotFound />;
  }

  return (
    <PageWithSidebar
      sidebar={<EntitySidebar entity={menu} />}
      breadcrumbs={[...breadcrumbs, { name: menu.displayName }]}>
      <MenuItemsList menu={menu} />
    </PageWithSidebar>
  );
};

export default withData<ContentMenuEditPageQuery, RouteParams>({
  query,
  loading: (
    <EntityEditPageSkeleton breadcrumbs={breadcrumbs}>
      <Paper sx={{ p: 2 }}>
        <TableSkeleton cols={2} />
      </Paper>
    </EntityEditPageSkeleton>
  ),

  variables: ({ routeParams }) => ({
    id: routeParams.id,
  }),
})(ContentMenuEditPage);
